module.exports = __webpack_public_path__ + "static/Abacus Zeiterfassung LEHMANNPARTNER-b52e9cbbef44a7f97178df2dc83a2015.pdf";